"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import type { ApiDrop, ApiWave } from "@/generated/models/ObjectSerializer";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WaveDropsAll from "../drops/wave-drops-all";
import { CreateDropWaveWrapper, CreateDropWaveWrapperContext } from "../CreateDropWaveWrapper";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator from "../PrivilegedDropCreator";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
import { DropMode } from "../dropComposer.types";
interface SingleWaveDropChatProps {
  readonly wave: ApiWave;
  readonly drop: ApiDrop;
}
export const SingleWaveDropChat: React.FC<SingleWaveDropChatProps> = t0 => {
  const $ = _c(28);
  const {
    wave,
    drop
  } = t0;
  const {
    isApp
  } = useDeviceInfo();
  const {
    isVisible: isKeyboardVisible
  } = useAndroidKeyboard();
  const t1 = isKeyboardVisible ? "0px" : "calc(env(safe-area-inset-bottom))";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      paddingBottom: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const inputContainerStyle = t2;
  let t3;
  if ($[2] !== drop) {
    t3 = {
      action: ActiveDropAction.REPLY,
      drop,
      partId: 1
    };
    $[2] = drop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [activeDrop, setActiveDrop] = useState(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = t5 => {
      const {
        targetDrop,
        partId,
        action
      } = t5;
      setActiveDrop({
        action,
        drop: targetDrop,
        partId
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleDropAction = t4;
  let t5;
  if ($[5] !== drop) {
    t5 = () => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId: 1
      });
    };
    $[5] = drop;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const resetActiveDrop = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = t7 => {
      const {
        drop: repliedDrop,
        partId: partId_0
      } = t7;
      return handleDropAction({
        targetDrop: repliedDrop,
        partId: partId_0,
        action: ActiveDropAction.REPLY
      });
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== activeDrop || $[9] !== drop.id || $[10] !== wave.id || $[11] !== wave.metrics.muted || $[12] !== wave.metrics.your_unread_drops_count) {
    t7 = <div className="tw-min-h-0 tw-flex-1"><WaveDropsAll waveId={wave.id} onReply={t6} activeDrop={activeDrop} initialDrop={null} unreadCount={wave.metrics.your_unread_drops_count} dropId={drop.id} isMuted={wave.metrics.muted} /></div>;
    $[8] = activeDrop;
    $[9] = drop.id;
    $[10] = wave.id;
    $[11] = wave.metrics.muted;
    $[12] = wave.metrics.your_unread_drops_count;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== inputContainerStyle || $[15] !== isApp) {
    t8 = isApp ? inputContainerStyle : {
      paddingBottom: "calc(env(safe-area-inset-bottom))"
    };
    $[14] = inputContainerStyle;
    $[15] = isApp;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== activeDrop || $[18] !== drop.id || $[19] !== resetActiveDrop || $[20] !== wave) {
    t9 = <CreateDropWaveWrapper context={CreateDropWaveWrapperContext.SINGLE_DROP}><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={resetActiveDrop} onDropAddedToQueue={resetActiveDrop} wave={wave} dropId={drop.id} fixedDropMode={DropMode.BOTH} /></CreateDropWaveWrapper>;
    $[17] = activeDrop;
    $[18] = drop.id;
    $[19] = resetActiveDrop;
    $[20] = wave;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div style={t8} className="tw-mt-auto">{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t7) {
    t11 = <div className="tw-flex tw-h-full tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-border-y-0 tw-border-l-0 tw-border-iron-800 tw-bg-iron-950 lg:tw-border lg:tw-border-r lg:tw-border-solid"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col">{t7}{t10}</div></div></div></div></div>;
    $[25] = t10;
    $[26] = t7;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};